import { SortState } from '@dynamika-shared/types/general';
import { SiteConfigurationType } from '@dynamika-shared/types/site';

export const sortSites = (
  sites: SiteConfigurationType[],
  sortBy?: string,
  currentPage = 1,
  currentPageSize = 10
) => {
  return [...sites]
    .sort((a, b) => {
      if (sortBy) {
        const [sortField, sortOrder] = sortBy.split(',') as [
          field: keyof SiteConfigurationType,
          order: SortState,
        ];
        const aSortValue = (a[sortField] as string) ?? '';
        const bSortValue = (b[sortField] as string) ?? '';
        return sortOrder === 'asc'
          ? aSortValue.localeCompare(bSortValue)
          : bSortValue.localeCompare(aSortValue);
      }
      return 0;
    })
    .slice((currentPage - 1) * currentPageSize, currentPage * currentPageSize);
};
